import React from "react";

import Tag from "./Tag";
import useFAST from "../../contexts/FASTContext";

import type { JSX } from "react";

interface Props {
  scheduleId: string;
  isFullWidth?: boolean;
  size?: "small" | "medium";
}

export default function FastScheduleTag({
  scheduleId,
  isFullWidth,
  size,
}: Props): JSX.Element {
  const { state } = useFAST();

  const { schedules } = state;

  const currentSchedule = schedules.find(
    (schedule) => schedule.uuid === scheduleId,
  );

  return (
    <Tag
      color={currentSchedule?.color ?? "gray"}
      isFullWidth={isFullWidth}
      size={size}
    >
      {currentSchedule?.name ?? scheduleId}
    </Tag>
  );
}
